/*
 * @Author: 'chenmengni'
 * @Date: 2025-03-07 09:30:37
 * @LastEditors: Tommy Chen weiyao_85@163.com
 * @LastEditTime: 2025-06-26 15:10:04
 * @FilePath: \help.center.intl\src\utils\query.js
 * @Description: 
 */
import $axios from '@/plugins/axios'
import { config } from '@/config'
/**
 *
 * @param {String} code 接口代码
 * @param {Object} data 接口参数
 * @returns {Promise<any>}
 */
// 海外
// const baseurl = "https://enet-as.ruijienetworks.com/bida/faq/"
// const searchurl = "https://enet-as.ruijienetworks.com/bida/open_search/search/faq"
// const replaceUrl = 'https://enet-as.ruijienetworks.com/llmopsprod/'

// 国内
// const baseurl = "https://reyee.ruijie.com.cn/bida/faq/"
// const searchurl = "https://reyee.ruijie.com.cn/bida/open_search/search/faq"
// const replaceUrl = 'https://reyee.ruijie.com.cn/llmopsprod/'

const baseurl = "https://enet-as.ruijienetworks.com/bida/faq/"
const searchurl = "https://enet-as.ruijienetworks.com/bida/open_search/search/faq"
const replaceUrl = 'https://enet-as.ruijienetworks.com/llmopsprod/'



$axios.postRequest = (url, data, loading = false) => {
    let params = {
        ContentType: "application/json",
        params: JSON.stringify(data),
    };
    return Promise.resolve(/*  */
        $axios.post(url, params, {
            loading
        })
    )
}

$axios.getRequest = (url) => {
    return Promise.resolve(
        $axios.get(url)
    )
}

$axios.getParamRequest = (url, data) => {
    let opts = {
        ...data
    };
    return Promise.resolve(
        $axios.get(url, { ...opts })
    )
}
// 获取ISP云服务图片
export function getIspcloudhomePng() {
    let url = replaceUrl + "wiki-api/queryWikiForMacc/e757285b2eb34e668ed9b7994615712e"
    return $axios.getRequest(url)
}
// 获取ISP云服务首页内容
export function getIspcloudhomeCategories() {
    let url = replaceUrl + "wiki-api/queryWikiForMacc/193cd11d896743ccb7799b3f5afdd54b"
    return $axios.getRequest(url)
}

//
// ISP的文档知识库ID：3f3e51881a56470b994afca594186987
// ISP更新说明：4ac8d553a7bb45c78bbf1adfd79f3ec1
// ISP快速指南：52720b1095db47ddb380f12abbf9e420
export function getIspCategories() {
    let url = replaceUrl + "wiki-api/queryWikiForMacc/3f3e51881a56470b994afca594186987"
    return $axios.getRequest(url)
}
export function getIspRelease() {
    let url = replaceUrl + "wiki-api/queryWikiForMacc/4ac8d553a7bb45c78bbf1adfd79f3ec1"
    return $axios.getRequest(url)
}

export function getIspQuickGuide() {
    let url = replaceUrl + "wiki-api/queryWikiForMacc/52720b1095db47ddb380f12abbf9e420"
    return $axios.getRequest(url)
}
// 3、请求文章
export function queryIspArticleList(keyword) {
    let url = replaceUrl + "wiki-api/esForBida?wikiId=4ac8d553a7bb45c78bbf1adfd79f3ec1,3f3e51881a56470b994afca594186987&keyword=" + keyword
    let headers = {
        headers: {
            'apiKey': 'L8fJkqU7w5Q3n2X1Yb8Z9A=='
        }
    }
    return $axios.getParamRequest(url, headers)
}

const helpWikiIds = {
    release: '084d310e4c044b5c8b803b4f4a5ff185',
    quickGuide: 'f30334ae42384e96985bfc91672f76ea',
    help: '2abdf92324eb4ddd921ad41387b222b0',
}

// 接口
// 0、请求文章内容的json的url
export function getJSON(url) {
    return $axios.getRequest(url)
}
// 1、请求文章目录
// categories() 用于获取 help 知识库的“用户指南”目录数据
// 返回包含目录结构的JSON数据，用于构建导航菜单
export function categories() {
    let url = replaceUrl + "wiki-api/queryWikiForMacc/" + helpWikiIds.help
    return $axios.getRequest(url)
}

// 1、请求发布说明目录
// categories2() 用于获取“更新说明”目录数据
export function categories2() {
    let url = replaceUrl + "wiki-api/queryWikiForMacc/" + helpWikiIds.release
    return $axios.getRequest(url)
}

// categories3() 用于获取“快速指南”目录数据
// 目录中的文章 ID 交给 articles()，再通过 getJSON() 加载文章正文。
export function categories3() {
    let url = replaceUrl + "wiki-api/queryWikiForMacc/" + helpWikiIds.quickGuide
    return $axios.getRequest(url)
}


// 2、请求文章
export function articles(id) {
    // let url = baseurl + "content?id=" + id
    let url = replaceUrl + "wiki/docsInfo/toReview?docId=" + id
    return $axios.getRequest(url)
}
// 3、请求文章
export function queryArticleList(keyword) {
    let url = replaceUrl + "wiki-api/esForBida?wikiId=" + helpWikiIds.release + "," + helpWikiIds.help + "&keyword=" + keyword
    let headers = {
        headers: {
            'apiKey': 'L8fJkqU7w5Q3n2X1Yb8Z9A=='
        }
    }
    return $axios.getParamRequest(url, headers)
}
